module.exports = "/_next/static/images/no-internet-06b566d1ae8fc3658a6a767f7c371891.svg";